import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors } from '@/colors';

const alertStyles = {
  info: {
    background: colors.NEUTRAL_0,
    border: colors.AJAIB_BLUE_5,
    color: colors.NEUTRAL_10,
    icon: colors.AJAIB_BLUE_5,
  },
  success: {
    background: colors.NEUTRAL_0,
    border: colors.GREEN_5,
    color: colors.NEUTRAL_10,
    icon: colors.GREEN_5,
  },
  caution: {
    background: colors.NEUTRAL_0,
    border: colors.YELLOW_5,
    color: colors.NEUTRAL_10,
    icon: colors.YELLOW_5,
  },
  error: {
    background: colors.NEUTRAL_0,
    border: colors.RED_6,
    color: colors.NEUTRAL_10,
    icon: colors.RED_6,
  },
  default: {
    background: colors.AJAIB_BLUE_9,
    border: colors.AJAIB_BLUE_9,
    color: colors.NEUTRAL_0,
    icon: colors.NEUTRAL_0,
  },
};

/**
 * func to get alert styles
 * @param {keyof typeof alertStyles} type
 * @returns
 */
export const getAlertStyles = (type) => alertStyles[type] || alertStyles.default;

export const StyledAlertContainer = styled.div`
  ${({ position }) => css`
    display: flex;
    justify-content: ${position};
    width: 100%;
    position: absolute;
    right: ${position === 'right' && '48px'};
    left: ${position === 'left' && '48px'};
    bottom: 64px;
  `}
`;

export const StyledAlert = styled.div`
  ${({ type, show }) => css`
    position: relative;
    display: ${show ? 'flex' : 'none'};
    align-items: center;

    min-width: 320px;
    padding: 24px 12px;
    border-radius: 12px;
    box-shadow: 0px 4px 8px rgba(51, 51, 51, 0.16);

    transition: opacity 0.15s linear;
    z-index: 9999;

    background-color: ${getAlertStyles(type).background};
    border: 1px solid ${getAlertStyles(type).border};

    > svg {
      /* Style for Icon */
      width: 20px;
      height: 20px;
      margin-right: 8px;
      color: ${getAlertStyles(type).icon};
    }
    > :not(svg) {
      /* Style for Text */
      color: ${getAlertStyles(type).color} !important;
    }
  `}
`;
